import React, { useEffect, useRef, useState } from 'react';

function FadeIn({ children, delay = 0 }) {
  const ref = useRef();
  useEffect(() => {
    const timer = setTimeout(() => {
      const observer = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); } },
        { threshold: 0.1 }
      );
      if (ref.current) observer.observe(ref.current);
      return () => observer.disconnect();
    }, delay);
    return () => clearTimeout(timer);
  }, [delay]);
  return <div ref={ref} className="fade-in">{children}</div>;
}

const photos = [
  { src: '/images/hero.jpg', alt: 'Event photography', category: 'Events' },
  { src: '/images/gallery1.jpg', alt: 'Portrait photography', category: 'Portraits' },
  { src: '/images/gallery2.jpg', alt: 'Photography work', category: 'Events' },
  { src: '/images/facebook.png', alt: 'Social media photography', category: 'Design' },
];

function Gallery() {
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') setLightbox(null); };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  return (
    <>
      <section className="section gallery-page">
        <h2>Gallery</h2>
        <p className="gallery-subtitle">A selection of our photography and design work</p>

        <div className="gallery-masonry">
          {photos.map((photo, i) => (
            <FadeIn key={i} delay={i * 100}>
              <div className="masonry-item" onClick={() => setLightbox(photo)}>
                <img src={photo.src} alt={photo.alt} loading="lazy" />
                <div className="masonry-overlay">
                  <span>{photo.category}</span>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>

        <div className="instagram-cta">
          <h3>See More on Instagram</h3>
          <p>Follow us for the latest photos and behind-the-scenes content.</p>
          <a
            href="https://www.instagram.com/official_megapixelphotos"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-btn ig-btn"
          >
            📷 @official_megapixelphotos
          </a>
        </div>
      </section>

      {lightbox && (
        <div className="lightbox" onClick={() => setLightbox(null)}>
          <button className="lightbox-close" onClick={() => setLightbox(null)} aria-label="Close">×</button>
          <img src={lightbox.src} alt={lightbox.alt} />
        </div>
      )}
    </>
  );
}

export default Gallery;
